import axios from 'axios';
import router from '@/router'
import qs from 'qs'
import { Toast } from 'vant';
import apiUrl from './config'
import store from '../store'

// const env = process.env
// if (env.NODE_ENV != 'development') {

axios.defaults.withCredentials = true
    // }

// axios.defaults.transformRequest = function(data) {
//   return qs.stringify(data)
// };

// http请求拦截器
axios.interceptors.request.use((config) => {
    // 在所有请求中添加token头
    if (config.url === '/api/services/app/Banner/Banners') {
        config.url = '/cms' + config.url
    } else {
        config.data = qs.stringify(config.data)
        config.url = apiUrl.API_BASE_URL + config.url
    }

    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    function guid() {
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    }
    config.guid = guid()
    config.headers.common["uuid"] = config.guid
    return config
}, (error) => {
    return error
})

// http响应拦截器  根据返回码统一处理msg
axios.interceptors.response.use((data, x) => {
    // app端不做控制

    if (data.config.des && !/ibmuc/.test(window.location.href)) {
        try {
            function add0(m) { return m < 10 ? '0' + m : m }

            function format(shijianchuo) {
                var time = new Date(shijianchuo);
                var y = time.getUTCFullYear();
                var m = time.getUTCMonth() + 1;
                var d = time.getUTCDate();
                var h = time.getUTCHours();
                var mm = time.getUTCMinutes();
                var s = time.getUTCSeconds();
                var fff = time.getUTCMilliseconds()
                return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s) + '.' + fff;
            }

            var endTime = new Date().getTime()
            if (endTime < this.sTime) {
                endTime = new Date().getTime()
            }
            var params = {
                "SourceID": 2,
                "AppName": 1,
                "FunctionName": 'WAP/' + data.config.url.split('?')[0].split('/').pop(),
                "FunctionDescription": '[郭鹏]' + data.config.des,
                "Code": data.config.guid,
                "RequestStartTime": format(data.config.sTime),
                "RequestEndTime": format(endTime),
                "TotalTimes": +endTime - +data.config.sTime,
                "Remark": '',
                "ServerIP": apiUrl.ServerIP,
                "Parames": '',
                "RequestIP": '',
                "Live": 1
            }
            if (data.request.readyState === 4 && data.request.status === 200) {
                params['Result'] = 1
            } else {
                params['Result'] = 0

            }
            var res = JSON.parse(data.request.responseText)
            if (data.request.readyState === 4 && data.request.status === 200 && !(res.success || res.res || res.Status === '0')) {
                params['Result'] = 2
            }
            $.ajax({
                url: apiUrl.logUrl,
                type: 'post',
                crossDomain: true,
                contentType: 'application/json',
                beforeSend: function(req) {
                    req.setRequestHeader('uuid', params.Code)
                },
                data: JSON.stringify(params)
            })

        } catch (error) {
            console.log(error)
        }
    }


    let url = data.config.url.split('/')
    let reqPath = url.pop();
    if (data.data.Status == 0 && !data.data.IsSuccess && reqPath != 'poundageConfirm' && reqPath != 'list' && reqPath != 'login' && location.href.indexOf('funds/paymenttransfer') == -1) {
        Toast({
            type: 'fail',
            mask: true,
            message: data.data.Data
        });
    }
    if (data.data.Status == -1) {
        if (localStorage.getItem('ppa')) {
            let clientid = localStorage.getItem('clientid')
            localStorage.clear();
            localStorage.setItem('clientid', clientid)
            Toast({
                type: 'fail',
                mask: true,
                message: '请重新登录(1)'
            });
            return
        } else {
            let clientid = localStorage.getItem('clientid')
            localStorage.clear();
            localStorage.setItem('clientid', clientid)
            if (store.state.userInfo.role == 4 || store.state.userInfo.role == 5) {
                window.location.href = '/login'
            } else {
                Toast({
                    type: 'fail',
                    mask: true,
                    message: '请重新登录(2)'
                });
                location.reload()
            }
        }
    }
    return data
}, (error) => {
    // app端不做控制
    if (localStorage.getItem('ppa')) {
        let clientid = localStorage.getItem('clientid')
        localStorage.clear();
        localStorage.setItem('clientid', clientid)
        Toast({
            type: 'fail',
            mask: true,
            message: '请重新登录(3)'
        });
        return
    } else {
        let errmsg = "服务器响应错误";
        if (error.response) {
            // 服务器返回错误码
            switch (error.response.status) {
                case 401:
                    if (store.state.userInfo.role == 4 || store.state.userInfo.role == 5) {
                        window.location.href = '/login'
                    } else {
                        errmsg = "请登录后操作";
                        // router.replace("/login");
                    }
                    break;
                // case 404:
                //     errmsg = "找不到页面";
                //     router.replace({
                //         name: 'error-404'
                //     });
                //     break;
            }
        }
        Toast({
            type: 'fail',
            mask: true,
            message: errmsg,
            duration: 2000
        });
    }
    // router.replace("/login");
    return error
})

export default axios


// WEBPACK FOOTER //
// ./src/axios/index.js